import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@material-ui/core';

import {
    MONEY_TRANSFER_CODE,
    PAYOUT,
    AEPS_CODE,
    CREDITCARDPAYMENT_CODE,
    VENDOR_PAY,
    PAY_POINT_CODE
} from 'Components/Helper/Messages';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { withStyles } from '@material-ui/core/styles';

const StyledTableCell = withStyles((theme) => ({
    body: {
        fontSize: 16,
        fontWeight: 'bold'
    }
}))(TableCell);
const ValueTableCell = withStyles((theme) => ({
    body: {
        fontSize: 16,
        fontWeight: 'bold',
        color: 'green'
    }
}))(TableCell);

export function NSDLAEPSResponseComponent({
    isOpen,
    isPrint,
    title,
    ServiceID,
    request,
    OkButtonTitle,
    OkButtonClick,
    PrintButtonTitle,
    PrintButtonClick
}) {
    const [open, setOpen] = useState(isOpen);
    const [print, setPrint] = useState(isPrint);
    const classes = commonStyle();
    const [bgColor, setBGColor] = useState('');
    const [width, setWidth] = useState('xs');

    useEffect(() => {
        if (parseInt(ServiceID) === AEPS_CODE) {
            setWidth('md');
        }

        if (title === 'SUCCESS') {
            setBGColor('#42b86f');
            return;
        }

        if (title === 'FAILURE' || title === 'REFUND') {
            setBGColor('#ff0000');
            return;
        }

        if (title === 'PROCESS' || title === 'PENDING') {
            setBGColor('#f58220');
            return;
        }
    }, []);

    const handleOkButtonClick = () => {
        setOpen(false);
        OkButtonClick();
    };

    const handlePrintButtonClick = () => {
        setOpen(false);
        PrintButtonClick();
    };

    const isPrintEnable = () => {
        if (
            parseInt(ServiceID) !== MONEY_TRANSFER_CODE &&
            parseInt(ServiceID) !== AEPS_CODE &&
            parseInt(ServiceID) !== PAYOUT &&
            parseInt(ServiceID) !== CREDITCARDPAYMENT_CODE &&
            parseInt(ServiceID) !== VENDOR_PAY &&
            parseInt(ServiceID) !== PAY_POINT_CODE
        )
            return false;

        if (title === 'FAILURE') return false;

        return true;
    };

    if (isOpen === undefined || isOpen === null || isOpen === false) {
        return null;
    }

    return (
        <Dialog
            open={open}
            onClose={() => {
                setOpen(false);
                OkButtonClick(false);
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle
                id="alert-dialog-title"
                className={classes.title}
                style={{ background: bgColor }}
            >
                {title}
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {parseInt(ServiceID) === AEPS_CODE ? (
                        <NSDLAEPS request={request} />
                    ) : null}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={1}>
                    {isPrintEnable() ? (
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Button
                                onClick={() => handlePrintButtonClick()}
                                className={
                                    classes.CustomSecondaryButtonStylePopup
                                }
                            >
                                {PrintButtonTitle ? PrintButtonTitle : 'PRINT'}
                            </Button>
                        </Grid>
                    ) : (
                        <Grid item xs={12} sm={12} md={6} lg={6}></Grid>
                    )}
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Button
                            onClick={() => handleOkButtonClick()}
                            className={classes.CustomSecondaryButtonStylePopup}
                        >
                            {OkButtonTitle ? OkButtonTitle : 'OK'}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}

const NSDLAEPS = (request) => {
    let data = request.request;
    const isBlank = (param) => {
        if (param === undefined) return true;
        if (param === null) return true;
        if (param === '') return true;
        return false;
    };

    let rows = [];
    if (!isBlank(data.TransactionDate)) rows.push(Data('Date&Time', data.TransactionDate));
    if (!isBlank(data.AgentName)) rows.push(Data('AgentName', data.AgentName));
     if (!isBlank(data.AadharNumber)) rows.push(Data('Aadhar Number', data.AadharNumber));
    if (!isBlank(data.ServiceName)) rows.push(Data('Service Name', data.ServiceName));
    if (!isBlank(data.ProductName)) rows.push(Data('Product Name', data.ProductName));
    if (!isBlank(data.TransactionID)) rows.push(Data('Transaction ID', data.TransactionID));
    if (!isBlank(data.BankRRN)) rows.push(Data('BankRRN', data.BankRRN));
    if (!isBlank(data.BankName)) rows.push(Data('BankName', data.BankName));
    if (!isBlank(data.Status)) rows.push(Data('Status', data.Status));
    if (!isBlank(data.Amount)) rows.push(Data('Amount', data.Amount));
    if (!isBlank(data.AvailableBalance.toString()))
        rows.push(Data('AvailableBalance', data.AvailableBalance.toString()));
    if (!isBlank(data.Message)) rows.push(Data('Message', data.Message));

    function Data(Parameter, Values) {
        return { Parameter, Values };
    } 

    const parseMiniStatement = (entries) => {
        const transactions = [];

        entries.forEach((entry) => {
            const balanceMatch = entry.match(/^Balance\s+([\d.]+)\s+(CR|DR)$/);
            if (balanceMatch) return; // Skip "Balance" lines here

            const match = entry.match(
                /^(\d{2}\/\d{2})(?:\s+[A-Z]+\s+)+(\d+)\s+(CR|DR)$/i
            );
            if (match) {
                const date = match[1];
                const rawAmount = match[2].replace(/^0+/, ''); // remove leading zeros
                const trimmedAmount = rawAmount.slice(0, -2); // remove last 2 digits
                const amount = trimmedAmount === '' ? '0' : trimmedAmount;
                const type = match[3];
                transactions.push({ date, type, amount });
            } else {
                // fallback if above fails
                const parts = entry.trim().split(/\s+/);
                if (parts.length >= 5) {
                    const date = parts[0];
                    const rawAmount = parts[3].replace(/^0+/, '');
                    const trimmedAmount = rawAmount.slice(0, -2);
                    const amount = trimmedAmount === '' ? '0' : trimmedAmount;
                    const type = parts[4];
                    transactions.push({ date, type, amount }); 
                }
            }
        });

        return transactions;
    };

    const formatMiniStatement = (entries) => {
        const transactions = parseMiniStatement(entries);

        return transactions.map((txn, index) => (
            <TableRow key={index}>
                <TableCell align="left" style={{ whiteSpace: 'nowrap' }}>
                    {txn.date} {txn.type}
                </TableCell>
                <TableCell align="right">{txn.amount}</TableCell>
            </TableRow>
        ));
    };

    return (
        <Grid item xs={12}>
            <TableContainer>
                <Table aria-label="customized table">
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.Parameter}>
                                <StyledTableCell align="left">
                                    {row.Parameter}
                                </StyledTableCell>
                                <ValueTableCell align="left">
                                    {row.Values}
                                </ValueTableCell>
                            </TableRow>
                        ))}

                        {!isBlank(data.NSDLMiniStmt) &&
                            Array.isArray(data.NSDLMiniStmt) && (
                                <>
                                    <TableRow>
                                        <StyledTableCell
                                            colSpan={2}
                                            align="center"
                                        >
                                            <strong>Mini Statement</strong>
                                        </StyledTableCell>
                                    </TableRow>
                                    {formatMiniStatement(data.NSDLMiniStmt)}

                                    {/* Display Balance from last entry if present */}
                                    {data.NSDLMiniStmt.some((e) =>
                                        e.startsWith('Balance:')
                                    ) && (
                                        <TableRow>
                                            <StyledTableCell align="left">
                                                Balance
                                            </StyledTableCell>
                                            <ValueTableCell align="right">
                                                {
                                                    data.NSDLMiniStmt.find(
                                                        (e) =>
                                                            e.startsWith(
                                                                'Balance:'
                                                            )
                                                    )?.split(':')[1]
                                                }
                                            </ValueTableCell>
                                        </TableRow>
                                    )}
                                </>
                            )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
};
